import CopyWithTooltip from '@/common/CopyWithTooltip'
import { formatAddress } from '@/helpers/formatters'
import { cn } from '@/theme/utils'

interface UiAddressCopyProps {
  address: string
  className?: string
  showFull?: boolean
  start?: number
  end?: number
}

export default function UiAddressCopy({
  address,
  className,
  showFull = false,
  start = 6,
  end = 6,
}: UiAddressCopyProps) {
  const display = showFull ? address : formatAddress(address, start, end)
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <span className='text-sm'>{display}</span>
      <CopyWithTooltip value={address} />
    </div>
  )
}
